"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find");

var _index = _interopRequireDefault(require("@/components/Pagination/index"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _lang = _interopRequireDefault(require("@/lang"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: "payChannelGroupCostMember:view",
  mixins: [_CustomTableColumn.default],
  props: ['channelGroupId', 'channelGroupName'],
  extends: _PermissionPage.default,
  components: {
    Pagination: _index.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      tableKey: 0,
      list: [],
      agentList: [],
      channelGroupList: [],
      organizationNameOption: [],
      total: 0,
      listLoading: true,
      updateChannelFlag: false,
      addDialogVisible: false,
      addNotedDialogVisible: false,
      queryParameter: {
        pageNum: 1,
        pageSize: 10,
        channelGroupId: "",
        orgCode: ""
      },
      addInformationParameter: {
        id: "",
        channelGroupName: "",
        channelGroupId: "",
        orgCode: "",
        organizationCodes: [],
        agentId: "",
        agentIds: [],
        remark: ""
      },
      controllerPath: "payChannelGroupCostMember",
      downloadLoading: false,
      multipleSelection: [],
      rules: {
        // organizationCodes: [
        //   {
        //     required: false,
        //     message:
        //       i18n.t("channel.organizationNameText") + " " +
        //       i18n.t("warningMessage.cannotBeEmpty"),
        //     trigger: "change",
        //   },
        // ],
        // agentIds: [
        //   {
        //     required: false,
        //     message:
        //       i18n.t("SMS.agentNameText") + " " +
        //       i18n.t("warningMessage.cannotBeEmpty"),
        //     trigger: "change",
        //   },
        // ],
        channelGroupName: [{
          required: true,
          message: _lang.default.t("channel.smsChannelGroupNameText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        channelDetail: [{
          required: true,
          message: _lang.default.t("channel.channelNameText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }]
      }
    };
  },
  created: function created() {
    //If channel group id is undefined, return to previous page
    if (this.channelGroupId !== undefined) {
      this.initList();
      this.getList();
    } else {//Go back to previous webpage
      // this.$store.dispatch('tagsView/delView', this.$route).then(() => {
      //   this.$router.go(-1);
      // })
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    //If channel group id is undefined, return to previous page
    if (this.channelGroupId !== undefined) {
      this.initList();
      this.getList();
    } else {
      //Go back to previous webpage
      this.$store.dispatch('tagsView/delView', this.$route).then(function () {
        _this2.$router.go(-1);
      });
    }
  },
  methods: {
    initList: function initList() {
      this.getAgents();
      this.getOrgs();
    },
    getList: function getList() {
      var _this3 = this;

      //Set the loading button for table
      this.listLoading = true; //Get channel group name from props

      this.addInformationParameter.channelGroupName = this.channelGroupName; //Get search parameters

      var params = this.getQueryParams();

      _httpUtils.default.post("payChannelGroupCostMember", "list", null, params).then(function (res) {
        _this3.list = res.data.rows;
        _this3.total = res.data.total;
      }).finally(function () {
        _this3.listLoading = false;
      });

      setTimeout(function () {
        _this3.listLoading = false;
      }, 1 * 1000);
    },
    getAgents: function getAgents() {
      var _this4 = this;

      _httpUtils.default.post("agent", "getAgents", null, null).then(function (res) {
        _this4.agentList = res.data;
      }).catch(function (err) {
        _this4.$message({
          type: "error",
          message: err.message
        });
      });
    },
    //Initial organization list
    getOrgs: function getOrgs() {
      var _this5 = this;

      _httpUtils.default.post("organization", "getOrgs", null, {}).then(function (res) {
        _this5.organizationNameOption = res.data;
      }).catch(function (res) {
        _this5.$notify({
          title: _lang.default.t('SMS.alarm'),
          message: res.message,
          type: 'error',
          duration: 2000
        });
      });
    },
    //Get search parameter for backend service
    getQueryParams: function getQueryParams() {
      return {
        pageNum: this.queryParameter.pageNum,
        pageSize: this.queryParameter.pageSize,
        orgCode: this.queryParameter.orgCode,
        agentId: this.queryParameter.agentId,
        channelGroupId: this.channelGroupId
      };
    },
    //Refresh table
    handleFilter: function handleFilter() {
      //Reset the page number of table
      this.queryParameter.pageNum = 1;
      this.getList();
    },
    //Get input parameters for backend service
    getAddInformationParameter: function getAddInformationParameter() {
      return {
        id: this.addInformationParameter.id,
        isForced: this.addInformationParameter.isForced,
        channelGroupId: this.channelGroupId,
        organizationCodeList: this.addInformationParameter.organizationCodes,
        agentIdList: this.addInformationParameter.agentIds,
        remark: this.addInformationParameter.remark
      };
    },
    //Show remark for adding channel in channel group
    handleAddNoted: function handleAddNoted() {
      this.addNotedDialogVisible = true;
      var remark;

      if (this.addInformationParameter.agentIds.length > 0) {
        remark = this.$t("warningMessage.channelGroupAddCostMemberAgentRemark");
      }

      if (this.addInformationParameter.organizationCodes.length > 0) {
        remark = this.$t("warningMessage.channelGroupAddCostMemberRemark");
      }

      if (remark) {
        this.remarkMessage = remark;
      }
    },
    handleAddCostMember: function handleAddCostMember() {
      var _this6 = this;

      this.addNotedDialogVisible = false;

      var _this = this;

      this.$refs["addInformation"].validate(function (valid) {
        if (valid) {
          var params = _this.getAddInformationParameter();

          var action; // if(this.addInformationParameter.agentIds.length > 0){
          //   action = "addAgent";
          // }

          if (_this6.addInformationParameter.organizationCodes.length > 0) {
            action = "add";
          }

          if (_this6.controllerPath && action) {
            _httpUtils.default.post(_this6.controllerPath, action, null, params).then(function (res) {
              if (res.code === 200) {
                if (action === "add") {
                  _this6.$message({
                    message: _lang.default.t("warningMessage.addGroupSuccessMessage"),
                    type: "success"
                  });
                }

                if (action === "update") {
                  _this6.$message({
                    message: _lang.default.t("warningMessage.updateGroupSuccessMessage"),
                    type: "success"
                  });
                }
              }

              _this6.handleResetAdd();

              _this6.handleFilter();
            }).catch(function (e) {
              _this6.$message({
                message: e.message,
                type: "error"
              });
            });
          }

          _this6.$refs["addInformation"].clearValidate();
        } else {
          return false;
        }
      });
    },
    deleteGroup: function deleteGroup(groupIds) {
      var _this7 = this;

      if (groupIds.length > 0) {
        _httpUtils.default.post(this.controllerPath, "batchDelete", null, groupIds).then(function (res) {
          _this7.$message({
            message: _lang.default.t("warningMessage.deleteRecordSuccessMessage"),
            type: "success"
          });

          _this7.handleFilter();
        }).catch(function (err) {
          _this7.$message({
            message: err.message,
            type: "error"
          });
        });
      }
    },
    handleDelete: function handleDelete(row) {
      var _this8 = this;

      var remark, messageBoxContent; // if(row.memberType === '1' || row.memberType === '2'){

      remark = _lang.default.t("warningMessage.channelGroupDeleteCostMemberRemark");
      messageBoxContent = _lang.default.t("warningMessage.deleteRecordMessage"); // }
      // if(row.memberType === '3'){
      //   remark = i18n.t("warningMessage.channelGroupDeleteCostMemberAgentRemark");
      //   messageBoxContent = i18n.t("warningMessage.deleteRecordMessage");
      // }

      this.$confirm(remark, messageBoxContent, {
        confirmButtonText: _lang.default.t("common.confirm"),
        cancelButtonText: _lang.default.t("common.cancel"),
        type: "warning"
      }).then(function () {
        var ids = [];
        ids.push(row.id);

        _this8.$nextTick(function (_) {
          _this8.deleteGroup(ids);
        });
      }).catch(function (_) {});
    },
    handleBatchDelete: function handleBatchDelete() {
      var _this9 = this;

      var _this = this;

      if (!_this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t("warningMessage.selectRecordToDeleteMessage"),
          type: "error"
        });
      } else {
        this.$confirm(_lang.default.t("warningMessage.channelGroupDeleteCostMemberRemark"), _lang.default.t("warningMessage.deleteRecordMessage"), {
          confirmButtonText: _lang.default.t("common.confirm"),
          cancelButtonText: _lang.default.t("common.cancel"),
          type: "warning"
        }).then(function () {
          var ids = [];

          for (var item in _this.multipleSelection) {
            ids.push(_this.multipleSelection[item].id);
          }

          _this9.$nextTick(function (_) {
            _this9.deleteGroup(ids);
          });
        }).catch(function (_) {});
      }
    },
    //Clear input parameters
    handleReset: function handleReset() {
      this.addNotedDialogVisible = false;
      this.remarkMessage = "";

      if (!this.updateChannelFlag) {
        this.addInformationParameter.id = "";
      }

      this.addInformationParameter.orgCode = "";
      this.addInformationParameter.organizationCodes = [];
      this.addInformationParameter.agentId = "";
      this.addInformationParameter.agentIds = [];
      this.addInformationParameter.remark = "";
    },
    //Reset validate for input parameters
    handleResetAdd: function handleResetAdd() {
      var _this10 = this;

      this.addDialogVisible = false;
      this.updateChannelFlag = false;
      this.handleReset();
      this.$nextTick(function () {
        _this10.$refs["addInformation"].clearValidate();
      });
    },
    convertOrganizationCode: function convertOrganizationCode(code) {
      if (!this.organizationNameOption || !this.organizationNameOption.length) return;
      var found = this.organizationNameOption.find(function (organization) {
        return organization.organizationCode === code;
      });

      if (found) {
        return found.organizationName;
      } else {
        return code;
      }
    },
    convertAgentName: function convertAgentName(id) {
      if (!this.agentList || !this.agentList.length) return;
      var found = this.agentList.find(function (agent) {
        return agent.agentId === parseInt(id);
      });

      if (found) {
        return found.agentName;
      } else {
        return id;
      }
    },
    //Handle add check boxes for table
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
exports.default = _default;